export const getProductGallery = ({ galleryImages, image}) => {
  let result = []

  galleryImages.edges.forEach(e => {
    result.unshift(e.node);
  });

  result.unshift(image)

  return result;
}